import React, { useState, useEffect } from 'react';
import styles from './sections.module.css';
import { publicSiteAPI } from '../../../services/api';
import { useScrollReveal } from '../hooks/useScrollReveal';

interface TimelineSectionProps {
  slug: string;
}

export const TimelineSection: React.FC<TimelineSectionProps> = ({ slug }) => {
  const ref = useScrollReveal();
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTimeline();
  }, [slug]);

  const loadTimeline = async () => {
    try {
      const data = await publicSiteAPI.getTimeline(slug);
      const combined = [
        ...(data.milestones || []).map((m: any) => ({
          title: m.name,
          description: m.description,
          date: m.date,
          completed: m.completed,
          type: 'milestone',
        })),
        ...(data.planningMilestones || []).map((m: any) => ({
          title: m.title,
          description: m.description,
          date: m.startDate || m.dueDate,
          completed: m.status === 'completed',
          type: m.type,
        })),
      ].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
      setItems(combined);
    } catch {
      // silent fail
    } finally {
      setLoading(false);
    }
  };

  if (loading || items.length === 0) return null;

  const now = new Date();

  return (
    <section id="timeline" className={styles.section} ref={ref}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>Tijdlijn</h2>
        <div className={styles.timeline}>
          {items.map((item, i) => {
            const date = new Date(item.date);
            const isPast = item.completed || date < now;
            const isCurrent = !item.completed && date >= now && (i === 0 || items[i - 1].completed || new Date(items[i - 1].date) < now);

            return (
              <div
                key={i}
                className={`${styles.timelineItem} ${isPast ? styles.timelinePast : ''} ${isCurrent ? styles.timelineCurrent : ''}`}
              >
                <div className={styles.timelineDot} />
                <div className={styles.timelineContent}>
                  <span className={styles.timelineDate}>
                    {date.toLocaleDateString('nl-NL', { year: 'numeric', month: 'long' })}
                  </span>
                  <h4 className={styles.timelineTitle}>{item.title}</h4>
                  {item.description && <p className={styles.timelineDesc}>{item.description}</p>}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
